import React from 'react'
import { Grid, Icon, Segment, SemanticICONS } from 'semantic-ui-react'

interface SmallSegmentProps {
  icon: SemanticICONS
  title: string
  value: number
}

export const SmallSegment: React.FC<SmallSegmentProps> = props => {
  return (
    <Segment className='small-segment' color='red' textAlign='center'>
      <Grid columns='equal'>
        <Grid.Row>
          <Grid.Column className='small-segment-label' textAlign='left'>
            <Icon name={props.icon} size='big' />
            <label>{props.title}</label>
          </Grid.Column>
          <Grid.Column width={2} className='small-segment-number' textAlign='right'>
            <label>{props.value}</label>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
  )
}
